import Swiper, { Pagination, Autoplay } from 'swiper';
// import Swiper and modules styles
import './index.css';

export default (element, data) => {
  const init = () => {
    const { enabled: autoplayIsEnabled, delay, disableOnInteraction, pauseOnMouseEnter } = data.slider.autoplay;
    const selector = element.querySelector('[data-slider]');
    const pagination = selector.querySelector('.swiper-pagination');

    const autoplay = {
      delay: delay * 1000,
      disableOnInteraction,
      pauseOnMouseEnter,
    };

    // eslint-disable-next-line no-unused-vars
    const slider = new Swiper(selector, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: element.querySelectorAll('.swiper-slide').length > 1,
      allowTouchMove: element.querySelectorAll('.swiper-slide').length > 1,
      pagination: {
        el: pagination,
        clickable: element.querySelectorAll('.swiper-slide').length > 1,
      },
      ...(autoplayIsEnabled && element.querySelectorAll('.swiper-slide').length > 1 && { autoplay }),
    });

    // set the max width of the button container based on the width (and gap) of the first two buttons
    // third button is centered below the first two and the button container aligns with the rest of the content
    const buttonContainer = selector.querySelector('.cta-container');
    const buttons = selector.querySelectorAll('.cta-base');
    if (buttons.length === 3 && buttonContainer) {
      const firstButtonWidth = buttons[0].offsetWidth;
      const secondButtonWidth = buttons[1].offsetWidth;
      buttonContainer.style.maxWidth = `${firstButtonWidth + secondButtonWidth + 10}px`;
    }
  };

  init();
};
